import checkoutShipmentHtml from './checkoutshipment.component.html';
import './checkoutshipment.component.scss';

class CheckoutShipmentController {
    constructor($scope, $timeout, CheckoutService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = CheckoutService;
        this.showCountrySelect = false;
    }

    $onInit() {
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (!newSummary) return;
                if (!this.service.loaded || this.service.loading) return;

                // New checkout value -> refresh payments and shipments
                if (!oldSummary || (oldSummary && newSummary.net_value_of_products_with_discount != oldSummary.net_value_of_products_with_discount)) {
                    this.service.loadShipments();
                    return;
                }

                if (oldSummary && newSummary.payment_id && newSummary.payment_id != oldSummary.payment_id) {
                    this.service.loadShipments();
                }
            },
            true
        );
    }

    setShipment(shipment, options = null) {
        this.service.setShipment(shipment, options);
    }
}

let checkoutShipmentComponent = {
    bindings: {},
    template: checkoutShipmentHtml,
    controller: CheckoutShipmentController
}

export default checkoutShipmentComponent;
